/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CurrencySymbol } from '../models/CurrencySymbol';
import type { EndDate } from '../models/EndDate';
import type { EventNote } from '../models/EventNote';
import type { FuelCurrencyDefault } from '../models/FuelCurrencyDefault';
import type { FuelPrice } from '../models/FuelPrice';
import type { FuelType } from '../models/FuelType';
import type { GroupsArray } from '../models/GroupsArray';
import type { StartDate } from '../models/StartDate';
import type { StationId } from '../models/StationId';
import type { StationIdentifier } from '../models/StationIdentifier';
import type { StationName } from '../models/StationName';
import type { StationStats } from '../models/StationStats';
import type { StationTankVolume } from '../models/StationTankVolume';
import type { StationTransactionAmount } from '../models/StationTransactionAmount';
import type { StationTransactionCurrency } from '../models/StationTransactionCurrency';
import type { StationTransactionDate } from '../models/StationTransactionDate';
import type { StationTransactionId } from '../models/StationTransactionId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class StationsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Export transactions
     * Export station transactions
     * @param stationId
     * @param startDate
     * @param type
     * @param endDate
     * @param transactionType
     * @returns any OK
     * @throws ApiError
     */
    public stationTransactionExport(
        stationId: Array<StationId>,
        startDate: StartDate,
        type: 'csv' | 'xlsx' | 'pdf' | 'grex',
        endDate?: EndDate,
        transactionType: 'in' | 'out' | null = null,
    ): Observable<Array<{
        identifier: StationIdentifier;
        station_id: StationId;
        transactions: Array<({
            amount: StationTransactionAmount;
            currency: StationTransactionCurrency;
            date: StationTransactionDate;
            fuel_type: FuelType;
            id: StationTransactionId;
            price: FuelPrice;
        } & EventNote)>;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/stations/transactions/export',
            query: {
                'station_id': stationId,
                'start_date': startDate,
                'end_date': endDate,
                'type': type,
                'transaction_type': transactionType,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                413: `Export data too large`,
                500: `Server error`,
                504: `Server error`,
            },
        });
    }
    /**
     * List all
     * List all available stations
     * @returns any OK
     * @throws ApiError
     */
    public stationListAll(): Observable<Array<{
        fuel_type: FuelType;
        groups: GroupsArray;
        id: StationId;
        identifier: StationIdentifier;
        name: StationName;
        tank_volume: StationTankVolume;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/stations/',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create
     * Create station
     * @param requestBody
     * @returns any Station created
     * @throws ApiError
     */
    public stationCreate(
        requestBody: {
            fuel_type: FuelType;
            groups: GroupsArray;
            identifier?: StationIdentifier;
            name: StationName;
            tank_volume: StationTankVolume;
        },
    ): Observable<{
        id: StationId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/stations/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit transaction
     * Edit station transaction
     * @param stationId Station ID
     * @param transactionId Transaction ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public stationTransactionEdit(
        stationId: string,
        transactionId: string,
        requestBody: ({
            amount?: StationTransactionAmount;
            currency?: StationTransactionCurrency;
            date?: StationTransactionDate;
            fuel_type?: FuelType;
            price?: FuelPrice;
        } & EventNote),
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/stations/{station_id}/transactions/{transaction_id}/',
            path: {
                'station_id': stationId,
                'transaction_id': transactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete transaction
     * Delete station transaction
     * @param stationId Station ID
     * @param transactionId Transaction ID
     * @returns void
     * @throws ApiError
     */
    public stationTransactionDelete(
        stationId: string,
        transactionId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/stations/{station_id}/transactions/{transaction_id}/',
            path: {
                'station_id': stationId,
                'transaction_id': transactionId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * List transactions
     * List station transactions
     * @param stationId Station ID
     * @param startDate
     * @param endDate
     * @returns any OK
     * @throws ApiError
     */
    public stationTransactionList(
        stationId: string,
        startDate: string,
        endDate?: string,
    ): Observable<{
        end_date: string;
        start_date: string;
        stats: {
            in: StationStats;
            out: StationStats;
        };
        transactions: Array<({
            amount: StationTransactionAmount;
            currency: StationTransactionCurrency;
            currency_symbol: CurrencySymbol;
            date: StationTransactionDate;
            fuel_type: FuelType;
            id: StationTransactionId;
            price: FuelPrice;
        } & EventNote)>;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/stations/{station_id}/transactions/',
            path: {
                'station_id': stationId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create transaction
     * Create station transaction
     * @param stationId Station ID
     * @param requestBody
     * @returns any Transaction created
     * @throws ApiError
     */
    public stationTransactionCreate(
        stationId: string,
        requestBody: ({
            amount: StationTransactionAmount;
            date: StationTransactionDate;
            fuel_type: FuelType;
        } & {
            currency?: StationTransactionCurrency;
            price?: FuelPrice;
        } & FuelCurrencyDefault & EventNote),
    ): Observable<{
        id: StationTransactionId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/stations/{station_id}/transactions/',
            path: {
                'station_id': stationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Detail
     * Get station details
     * @param stationId Station ID
     * @returns any OK
     * @throws ApiError
     */
    public stationDetail(
        stationId: string,
    ): Observable<{
        fuel_type: FuelType;
        groups: GroupsArray;
        id: StationId;
        identifier: StationIdentifier;
        name: StationName;
        tank_volume: StationTankVolume;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/stations/{station_id}/',
            path: {
                'station_id': stationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit
     * Edit station
     * @param stationId Station ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public stationEdit(
        stationId: string,
        requestBody: {
            fuel_type?: FuelType;
            identifier?: StationIdentifier;
            name?: StationName;
            tank_volume?: StationTankVolume;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/stations/{station_id}/',
            path: {
                'station_id': stationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete
     * Delete station
     * @param stationId Station ID
     * @param permanent
     * @returns void
     * @throws ApiError
     */
    public stationDelete(
        stationId: string,
        permanent: boolean = false,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/stations/{station_id}/',
            path: {
                'station_id': stationId,
            },
            query: {
                'permanent': permanent,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
